import './topology-controlbar.css';
export default {
  "button": "pf-c-button",
  "modifiers": {
    "tertiary": "pf-m-tertiary",
    "disabled": "pf-m-disabled"
  },
  "topologyControlBar": "pf-topology-control-bar",
  "topologyControlBarButton": "pf-topology-control-bar__button"
};